import React from 'react';
import './CrmLoginLayout.scss';

/**
 * CRM giriş ekranı – dikey bölünmüş:
 * - Sol 2/3: Mavi zemin, gerçek foto (gölge efekti, kimlik belirsiz)
 * - Sağ 1/3: Login paneli, mavi alana hafif taşarak
 *
 * Görsel: public/media/image.png (kızıl saçlı, mavi gözlü – gölge efekti ile)
 */
export default function CrmLoginLayout({ children }) {
  const heroSrc = `${process.env.PUBLIC_URL || ''}/media/image.png`;
  return (
    <div className="crm-login-layout">
      <div className="crm-login-background">
        <div className="crm-login-background-content">
          <div className="crm-logo">
            <span className="crm-logo-icon">⚡</span>
            <span className="crm-logo-text">
              <span className="crm-logo-main">CRM</span>
              <span className="crm-logo-sub">Yonetim</span>
            </span>
          </div>
          <h1 className="crm-title">Müşteri İlişkileri Yönetimi</h1>
          <p className="crm-subtitle">Cari takip · Satış yönetimi · Randevu & işlem planlama</p>
        </div>
        <div className="crm-login-hero">
          <img src={heroSrc} alt="" aria-hidden />
        </div>
      </div>
      <div className="crm-login-panel-wrapper">
        <div className="crm-login-panel">
          {children}
        </div>
      </div>
    </div>
  );
}
